// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"96":"754d7593","348":"754d7593"}[chunkId] + ".chunk.css";
};